import { Button, Device, Loading, Theme } from '@livecontrol/core-ui';
import { Event } from '@livecontrol/scheduler/model';
import { useMemo } from 'react';
// import type { TroubleshootingContact } from '../../../../graphql-types';
import { MasqueradeToken } from '../../../../model';
import { Store, store } from '../../../../store';
import type { ScheduledEvent } from '../../graphql';
import { useContacts } from '../../graphql';
import { TroubleshootingGrid } from './troubleshooting-grid';
import { TroubleshootingStack } from './troubleshooting-stack';
import { UserGrid } from './user-grid';
import { UserStack } from './user-stack';

export const Contacts = ({
  scheduledEvent
}: {
  scheduledEvent?: ScheduledEvent;
}): React.ReactElement => {
  const { token } = Store.User.useIdentity();
  const { environment } = store.getState();
  const viewport = Theme.useViewport();

  const { contacts } = useContacts(scheduledEvent?.location?.id, scheduledEvent?.location?.user?.id);

  const editTroubleshootingContactsURL = useMemo((): string | undefined => {
    if (token && !!scheduledEvent && !!scheduledEvent.location?.user) {
      const decoded = MasqueradeToken.decode(token.jwt);

      return decoded
        ? `${environment.DASHBOARD_URI}/masquerade#token=${decoded.jwt}&xref=${scheduledEvent.location.user.id}:${
            scheduledEvent.location.user.id
          }&redirect=%2Faccount%2Fusers`
        : undefined;
    }

    return undefined;
  }, [environment, token, scheduledEvent]);

  if (!scheduledEvent) {
    return <Loading isOldVersion={true}/>;
  }


  const on_site_contact = scheduledEvent.on_site_contact ? {
    user: {
      id: '',
      first_name: scheduledEvent.on_site_contact.first_name,
      email: scheduledEvent.on_site_contact.email,
      phone_number: scheduledEvent.on_site_contact.phone_number,
      preferred_contact_method: scheduledEvent.on_site_contact.preferred_contact_method
    }
  } : undefined;

  const technicalContact = on_site_contact ? on_site_contact :
    scheduledEvent.linkedEvent && (scheduledEvent.event_type === Event.EventType.MobileKit || scheduledEvent.event_type === Event.EventType.Mobile) ?
      scheduledEvent.linkedEvent.technical_contact :
      scheduledEvent.technical_contact;

  return (
    <div className='text-white'>
      {technicalContact && (
        <>
        <h2 className='mt-24px mb-16px'>Primary Contact</h2>
        {Device.isMobile(viewport) ? (
          <UserStack
            users={[
              {
                id: technicalContact.user?.id ?? '',
                name: technicalContact.user?.first_name ?? '',
                email: technicalContact.user?.email ?? '',
                phoneNumber: technicalContact.user?.phone_number ?? '',
                priority: 'Event',
                contactMethod: technicalContact.user?.preferred_contact_method ?? ''
              }
            ]}
          />
        ) : (
          <UserGrid
            users={[
              {
                id: technicalContact.user?.id ?? '',
                name: technicalContact.user?.first_name ?? '',
                email: technicalContact.user?.email ?? '',
                phoneNumber: technicalContact.user?.phone_number ?? '',
                priority: 'Event',
                contactMethod: technicalContact.user?.preferred_contact_method ?? ''
              }
            ]}
          />
        )}
      </>)}

      <div className='mt-24px mb-16px d-flex justify-content-between'>
        <h2>Troubleshooting Contacts</h2>
        <Button
          href={editTroubleshootingContactsURL}
          target='_blank'
          variant='secondary'
          className='btn-round'
        >
          <i className='m-4px far fa-edit' />
        </Button>
      </div>
      {contacts ? (
        Device.isMobile(viewport) ? (
          <TroubleshootingStack contacts={contacts} />
        ) : (
          <TroubleshootingGrid contacts={contacts} />
        )
      ) : null}

    </div>
  );
};
